import { render } from "./IpgTransactionSkelton.vue?vue&type=template&id=4df56fb7&scoped=true&ts=true"
import script from "./IpgTransactionSkelton.vue?vue&type=script&lang=ts"
export * from "./IpgTransactionSkelton.vue?vue&type=script&lang=ts"

import "./IpgTransactionSkelton.vue?vue&type=style&index=0&id=4df56fb7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df56fb7"]])

export default __exports__